import { render, staticRenderFns } from "./OverlayDictCriteria.vue?vue&type=template&id=10af4316&scoped=true"
import script from "./OverlayDictCriteria.vue?vue&type=script&lang=js"
export * from "./OverlayDictCriteria.vue?vue&type=script&lang=js"
import style0 from "./OverlayDictCriteria.vue?vue&type=style&index=0&id=10af4316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af4316",
  null
  
)

export default component.exports